/**
 * Formats a date string to "YYYY-MM-DD HH:mm" format
 * @param dateString - Date string in various formats (ISO, etc.)
 * @returns Formatted date string in "YYYY-MM-DD HH:mm" format (e.g., "2025-12-29 14:30")
 */
export const formatDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      // If date parsing fails, return the original string
      return dateString;
    }
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  } catch (error) {
    // If any error occurs, return the original string
    return dateString;
  }
};

/**
 * Formats a date string to "YYYY-MM-DD HH:mm" format
 * @param dateString - Date string in various formats (ISO, etc.)
 * @returns Formatted date string in "YYYY-MM-DD HH:mm" format (e.g., "2025-12-29 14:30")
 */
export const formatDateWithRelativeTime = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return dateString;
    }
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  } catch (error) {
    return dateString;
  }
};

